/*
 * Абсолютом от угла окна: крестик стоит над содержимым, а не в потоке, — иначе
 * он сдвигал бы заголовок вниз ровно на свою высоту в каждом диалоге.
 */
.close {
	position: absolute;
	top: 12px;
	right: 12px;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 32px;
	height: 32px;
	padding: 0;
	border: none;
	border-radius: var(--Border-radius-XXS);
	background: none;
	color: var(--text-tertiary);
	font-size: 20px;
	cursor: pointer;
}

.close:hover:not(:disabled) {
	background: var(--bg-dark-quartiary);
	color: var(--text-constant-dark);
}

.close:disabled {
	color: var(--text-disable);
	cursor: default;
}
